import { ErrorCode } from 'react-dropzone-latest';

export enum additionalErrorCodes {
  fileReadingFailed = 'file-reading-failed',
  fileReadingAborted = 'file-reading-aborted',
}

export const dropzoneMessageForErrorCodes: {
  [key in ErrorCode & additionalErrorCodes]: string;
} = {
  [ErrorCode.FileInvalidType]: 'Invalid file type',
  [ErrorCode.FileTooLarge]: 'File too large',
  [ErrorCode.FileTooSmall]: 'File too small',
  [ErrorCode.TooManyFiles]: 'Too many files',
  [additionalErrorCodes.fileReadingFailed]: 'File reading was failed',
  [additionalErrorCodes.fileReadingAborted]: 'File reading was aborted',
};
